import { Typography } from '@mui/material';
import { useStateWithRef } from 'src/@core/hooks/useStateWithRef';
import DarkModeSwitch from 'src/layouts/components/panels/userprofile/components/DarkModeSwitch';

interface CustomToggleProps {
  fieldStyles: any;
  updateCallback: ((row: any, value: any) => any) | undefined;
  row: any;
  col: any;
}

const CustomToggle = ({ fieldStyles, updateCallback, row, col }: CustomToggleProps) => {
  const [, setToggleDisabled, toggleDisabledRef] = useStateWithRef(false);

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  return (
    <>
      <Typography noWrap component="a" variant="body2" sx={{ ...fieldStyles, ml: '10px', alignContent: 'center' }}>
        <DarkModeSwitch
          name="toggle"
          checked={row[col.field]}
          disabled={toggleDisabledRef.current}
          onChange={async (event, checked) => {
            setToggleDisabled(true);
            const newRow = { ...row };
            newRow[col.field] = checked;
            if (updateCallback) {
              updateCallback(newRow, checked);
              await delay(1500);
              setToggleDisabled(false);
            }
          }}
        />
      </Typography>
    </>
  );
};

export default CustomToggle;
